import SalesAdjustmentContainer from './sales-adjustment-container';

export default SalesAdjustmentContainer;
